import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Box, Text } from 'grommet';

import style from './style.scss';

const HabitatFavorite = ({ onClick, icon, color, spin, className, isFavorited }) => {
  return (
    <Box onClick={onClick} className={clsx(style.fav, className)} direction="row" align="center" justify="center">
      <FontAwesomeIcon icon={icon} color={color} spin={spin} />
      <Text weight={500}>{isFavorited ? 'Following' : 'Follow'}</Text>
    </Box>
  );
};

export default HabitatFavorite;
